import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { makeStyles } from "@material-ui/core/styles";

import CustomTextInput from '../../components/CustomTextInput';
import CustomButton from '../../components/CustomButton';
import CustomToast from '../../components/CustomToast';
import LoadingOverlay from '../../components/LoadingOverlay';
import CustomBoardNewLogin from '../../components/CustomBoardNewLogin';

import * as selector from '../../../common/selectors';
import * as registrationAction from '../../../common/actions/registration';
import * as regSelector from '../../../common/selectors';

import AuthManager from '../../../utils/AuthManager';
import Color from "../../../utils/Color";
import CustomText, { getFontSize, getFontWeight } from '../../components/CustomText';

import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css'; // Must import the CSS
import CustomModal from '../../components/CustomModal';
import { Grid, Typography, IconButton } from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
import InfoIcon from '@material-ui/icons/Info';
import CloseIcon from '@material-ui/icons/Close';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
// import AddIcon from '@material-ui/icons/Add';
import { Add } from '@material-ui/icons';
import infoIconV2 from '../../../assets/img/info.svg';
import xIcon from '../../../assets/img/x.svg';
import pdfSvgIcon from '../../../assets/img/pdfSvg.svg';
import { t } from 'prettier';
// Simple regex
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const passwordRegex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;

const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: "2rem",
    paddingLeft: '2.7rem',
    paddingRight: '2.7rem',
    [theme.breakpoints.down('sm')]: {
      paddingTop: "0rem",
      paddingLeft: '0rem',
      paddingRight: '0rem',
    },
  },
  headerText: {
    color: '#000000',
    fontSize: 28,
    fontWeight: 700,
    [theme.breakpoints.down('sm')]: {
      fontSize: 24,
    },
  },
  infoBanner: {
    backgroundColor: '#F0F9FF',
    borderRadius: '8px',
    padding: '12px',
    marginBottom: '24px',
    fontSize: '14px',
    color: '#0EA5E9',
    display: 'flex',
    // alignItems: 'center',
  },
  infoIcon: {
    color: '#0EA5E9',
    paddingTop: '0.1rem',
    alignSelf: 'baseline',
    marginRight: '8px',
  },
  field: {
    marginBottom: '24px',
  },
  label: {
    display: 'block',
    fontSize: '14px',
    color: '#171717',
    fontWeight: 'bold',
    marginBottom: '8px',
  },
  uploadPreview: {
    backgroundColor: '#F0F0F0',
    borderRadius: '8px',
    padding: '12px',
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    cursor: 'pointer',
  },
  previewText: {
    fontSize: '14px',
    color: '#000000',
    display: 'flex',
    flexDirection: 'column'
  },
  removeBtn: {
    position: 'absolute',
    // top: '50%',
    right: '12px',
    transform: 'translateY(-50%)',
    color: '#000000',
    width: '17px'
  },
  uploadBtn: {
    width: '100%',
    height: '48px',
    backgroundColor: '#FFFFFF',
    border: '1px solid #0EA5E9',
    borderRadius: '8px',
    color: '#000000',
    fontSize: '14px',
    cursor: 'pointer',
    textAlign: 'left',
    paddingLeft: '12px',
    display: 'flex',
    alignItems: 'center'
  },
  verifyBtn: {
    width: '100%',
    height: '48px',
    backgroundColor: '#FFC107',
    color: '#000000',
    fontWeight: 'bold',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    marginTop: '32px',
    '&:hover': {
      backgroundColor: '#FFB300',
    },
  },
  modalContent: {
    position: 'relative',
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalImage: {
    maxWidth: '90%',
    maxHeight: '90%',
  },
  modalIframe: {
    width: '90vw',   // 90% of viewport width
    height: '90vh',  // 90% of viewport height
    border: 'none',
  },

  closeBtn: {
    position: 'absolute',
    top: '-3rem',
    right: '-0.5rem',
    color: '#000000',
  },
  // Existing styles from previous code can be added here if needed
  labelTextInputTextStyle: {
    fontWeight: 500,
    fontSize: 14,
    color: '#666666',
    [theme.breakpoints.down('sm')]: {
      fontSize: 13,
    },
  },
  // ... (add other styles as needed from previous code)
}));

const IdentityVerification = () => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();

  // States for file uploads
  const [frontFile, setFrontFile] = useState(null);
  const [frontPreview, setFrontPreview] = useState(null);
  const [frontType, setFrontType] = useState(null);
  const [backFile, setBackFile] = useState(null);
  const [backPreview, setBackPreview] = useState(null);
  const [backType, setBackType] = useState(null);

  // Modal states for preview
  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
  const [selectedPreview, setSelectedPreview] = useState(null);
  const [selectedType, setSelectedType] = useState(null);

  // Other states similar to previous code
  const [customToastStatus, setCustomToastStatus] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [isVisible, setIsVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [calledApi, setCalledApi] = useState(false);
  // --------------------------
  // Redux Selectors for OCR Upload
  // --------------------------
  const uploadOcrNricData = useSelector(regSelector.uploadOcrNricData);
  const uploadOcrNricLoading = useSelector(regSelector.uploadOcrNricLoading);

  // Determine if back image is mandatory (1 = yes, 0 = no)
  const requireBackFile = localStorage.getItem('requireBack') === '1';
  const docType = localStorage.getItem('docType') || 'NRIC/FIN';

  // --------------------------
  // Helper: Convert file to Base64 string (without data prefix)
  // --------------------------
  const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const result = reader.result;
        // Remove data URL prefix if present
        const base64 = result.includes(',') ? result.split(',')[1] : result;
        resolve(base64);
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  };

  // Example useEffect if needed, adapted from previous
  useEffect(() => {
    return () => {
      // Cleanup on unmount
      setCalledApi(false)
    };
  }, []);


  const handleFileUpload = (event, type) => {
    const file = event.target.files[0];
    if (!file) return;

    // Validate size (5MB = 5242880 bytes)
    if (file.size > 5242880) {
      setCustomToastStatus(true);
      setToastMessage('File size exceeds 5MB.');
      return;
    }

    // Validate type
    const allowedTypes = ['image/jpeg', 'image/png', 'application/pdf'];
    if (!allowedTypes.includes(file.type)) {
      setCustomToastStatus(true);
      setToastMessage('Invalid file type. Only JPG, PNG, or PDF allowed.');
      return;
    }

    // Create object URL for preview (works for both image and PDF)
    const objectUrl = URL.createObjectURL(file);

    if (type === 'front') {
      setFrontPreview(objectUrl);
      setFrontFile(file);
      setFrontType(file.type);
    } else {
      setBackPreview(objectUrl);
      setBackFile(file);
      setBackType(file.type);
    }
  };

  const removePreview = (type) => {
    if (type === 'front') {
      if (frontPreview) URL.revokeObjectURL(frontPreview);
      setFrontPreview(null);
      setFrontFile(null);
      setFrontType(null);
    } else {
      if (backPreview) URL.revokeObjectURL(backPreview);
      setBackPreview(null);
      setBackFile(null);
      setBackType(null);
    }
  };

  const openPreviewModal = (preview, fileType) => {
    setSelectedPreview(preview);
    setSelectedType(fileType);
    setIsPreviewModalOpen(true);
  };

  const closePreviewModal = () => {
    setIsPreviewModalOpen(false);
    setSelectedPreview(null);
    setSelectedType(null);
  };

  // Replace validateForm with submit logic
  const onSubmitDocuments = async () => {
    if (!frontFile) {
      setCustomToastStatus(true);
      setToastMessage('Please upload the front document.');
      return;
    }
    if (requireBackFile && !backFile) {
      setCustomToastStatus(true);
      setToastMessage('Please upload the back document.');
      return;
    }

    setIsLoading(true);

    try {
      const ocrFiles = [];
      const frontBase64 = await fileToBase64(frontFile);
      ocrFiles.push({
        FileData: frontBase64,
        FileType: frontFile.type,
        FileName: frontFile.name,
      });
      if (requireBackFile && backFile) {
        const backBase64 = await fileToBase64(backFile);
        ocrFiles.push({
          FileData: backBase64,
          FileType: backFile.type,
          FileName: backFile.name,
        });
      }

      try {
        // Call reCAPTCHA API to get the token
        const recaptchaToken = await window.grecaptcha.execute(
          "6Lce7OMZAAAAALxOm9WwIETw1EL9UB73SDe4g0Tx",
          { action: "WEB_REGISTRATION_UPLOAD_OCR" }
        );

        if (!recaptchaToken) {
          setCustomToastStatus(true)
          setToastMessage("Unable to verify reCAPTCHA. Please try again.")
          return;
        }

        const payload = {
          NRIC: localStorage.getItem("NRIC"),
          OCRFile: ocrFiles,
          DOB: localStorage.getItem('dobOCR'),
          RecaptchaToken: recaptchaToken
        }

        dispatch(registrationAction.uploadOcrNric(payload));
        setCalledApi(true)

      } catch (error) {
        setCustomToastStatus(true)
        setToastMessage("Error during reCAPTCHA verification. Please try again.")
      }



    } catch (error) {
      setIsLoading(false);
      setCustomToastStatus(true);
      setToastMessage('Failed to process files. Please try again.');
    }
  };

  // --------------------------
  // Handle OCR Upload Response
  // --------------------------
  useEffect(() => {
    console.log("uploadOcrNricLoading", uploadOcrNricLoading)
    if (uploadOcrNricLoading) return;

    setIsLoading(false);

    if (uploadOcrNricData && calledApi) {
      const resp = uploadOcrNricData;
      const status = resp?.Data?.Status;
      const registrationId = resp?.Data?.RegistrationId;

      if (status === 'ERROR') {
        history.push('/OnboardingErr?key=syserror');
        return;
      }
      if (registrationId) {
        localStorage.setItem('registrationId', registrationId);
        sessionStorage.setItem("OCRStatus", status)
        history.push('/OnboardingLanding');
        return;
      }
      // Fallback: show toast with message
      setCustomToastStatus(true);
      setToastMessage('Unable to process your documents. Please try again.');
    }
  }, [uploadOcrNricData]);

  const handleCloseCustomToast = (event, reason) => {
    if (reason === 'clickaway') return;
    setCustomToastStatus(false);
  };

  const onClickNextButton = () => {
    history.push("/");
  };

  function shortenFileName(fileName, maxLength = 30) {
    if (!fileName) return '';

    const dotIndex = fileName.lastIndexOf('.');
    if (dotIndex === -1) return fileName; // no extension

    const name = fileName.substring(0, dotIndex);
    const ext = fileName.substring(dotIndex);

    // If too short, return as is
    if (fileName.length <= maxLength) return fileName;

    // Show first part + "..." + extension
    return name.substring(0, 30) + '...' + ext;
  }


  const renderPage = () => {
    return (
      <div className={classes.container}>
        <Typography variant="h1" className={classes.headerText}>
          Verify your identity
        </Typography>

        <div className={classes.infoBanner} style={{ marginTop: '1.2rem' }}>
          <img
            src={infoIconV2}
            className={classes.infoIcon}
          />
          {/* <InfoIcon className={classes.infoIcon} /> */}
          <div style={{ display: 'flex', flexDirection: 'column' }}><div style={{ fontWeight: 'bold' }}>Your privacy is important to us</div> <div style={{ marginTop: '0.4rem' }}>To better protect your personal information, we require an additional verification step.</div></div>
        </div>

        <form encType="multipart/form-data">
          <div className={classes.field}>
            <label className={classes.label} htmlFor="front">
              {docType == "PASSPORT" ? "Passport" : docType} {docType == "PASSPORT" ? '' : 'Front'} <span style={{ fontSize: '10px', color: '#686868' }}>(JPG, PNG, or PDF, max 5MB).</span>
            </label>
            {frontPreview ? (
              <div className={classes.uploadPreview} onClick={() => openPreviewModal(frontPreview, frontType)}>
                {/* <span className={classes.previewText}>{frontFile.name} Preview</span> */}
                <img src={frontType === 'application/pdf' ? pdfSvgIcon : frontPreview} style={{ width: '3rem', marginRight: '0.4rem' }} />
                <div className={classes.previewText}><div style={{ fontWeight: 'bold' }}>{shortenFileName(frontFile.name)}</div><div style={{ color: '#0EA5E9' }}>Preview</div> </div>
                {/* <IconButton className={classes.removeBtn} onClick={(e) => { e.stopPropagation(); removePreview('front'); }}>
                  <CancelIcon />
                </IconButton> */}
                <img
                  src={xIcon}
                  className={classes.removeBtn}
                  onClick={(e) => { e.stopPropagation(); removePreview('front'); }}
                />
              </div>
            ) : (
              <button
                type="button"
                className={classes.uploadBtn}
                onClick={() => document.getElementById('front').click()}
              >
                <span style={{ fontWeight: 'bold' }}><Add style={{ width: '1rem', marginTop: '0.1rem' }} />&nbsp;</span> <span style={{ fontWeight: 'bold', color: '#0EA5E9' }}>Upload document</span>
              </button>
            )}
            <input
              type="file"
              id="front"
              accept="image/jpeg,image/png,application/pdf"
              onChange={(e) => handleFileUpload(e, 'front')}
              style={{ display: 'none' }}
            />
          </div>

          {requireBackFile && (
            <div className={classes.field}>
              <label className={classes.label} htmlFor="back">
                {docType} Back <span style={{ fontSize: '10px', color: '#686868' }}>(JPG, PNG, or PDF, max 5MB).</span>
              </label>
              {backPreview ? (
                <div className={classes.uploadPreview} onClick={() => openPreviewModal(backPreview, backType)}>
                  <img src={backType === 'application/pdf' ? pdfSvgIcon : backPreview} style={{ width: '3rem', marginRight: '0.4rem' }} />
                  <div className={classes.previewText}><div style={{ fontWeight: 'bold' }}>{shortenFileName(backFile.name)}</div><div style={{ color: '#0EA5E9' }}>Preview</div> </div>
                  {/* <IconButton className={classes.removeBtn} onClick={(e) => { e.stopPropagation(); removePreview('back'); }}>
                    <CancelIcon />
                  </IconButton> */}
                  <img
                    src={xIcon}
                    className={classes.removeBtn}
                    onClick={(e) => { e.stopPropagation(); removePreview('back'); }}
                  />
                </div>
              ) : (
                <button
                  type="button"
                  className={classes.uploadBtn}
                  onClick={() => document.getElementById('back').click()}
                >
                  <span style={{ fontWeight: 'bold' }}><Add style={{ width: '1rem', marginTop: '0.1rem' }} />&nbsp;</span> <span style={{ fontWeight: 'bold', color: '#0EA5E9' }}>Upload document</span>
                </button>
              )}
              <input
                type="file"
                id="back"
                accept="image/jpeg,image/png,application/pdf"
                onChange={(e) => handleFileUpload(e, 'back')}
                style={{ display: 'none' }}
              />
            </div>
          )}

          <button type="button" className={classes.verifyBtn} onClick={onSubmitDocuments}>
            Verify
          </button>
        </form>
      </div>
    );
  };

  const renderMaintenanceChild = () => <></>;
  const height = 800;
  const width = 600;

  const modalContainer = () => {
    return (
      <div>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <CustomText style={{ fontWeight: 'bold', fontSize: 25, marginBottom: 10 }}>
              {/* Example modal content */}
              Verification in progress...
            </CustomText>
          </Grid>
        </Grid>
      </div>
    );
  };

  const previewModalContent = () => {
    return (
      <div className={classes.modalContent}>
        <IconButton className={classes.closeBtn} onClick={closePreviewModal}>
          <CloseIcon />
        </IconButton>
        {selectedType === 'application/pdf' ? (
          <iframe src={selectedPreview} className={classes.modalIframe} title="PDF Preview" />
        ) : (
          <img src={selectedPreview} alt="Document Preview" className={classes.modalImage} />
        )}
      </div>
    );
  };

  return (
    <>
      <CustomBoardNewLogin
        maintenanceChild={renderMaintenanceChild()}
        children={renderPage()}
        height={height}
        width={width}
      />
      <CustomToast
        open={customToastStatus}
        handleCloseCustomToast={handleCloseCustomToast}
        title={toastMessage}
        backToHome={false}
        warning
      />

      <CustomModal
        open={isVisible}
        modalDesign={{}} // Add styles if needed
        submitButtonText={"OK"}
        modalComponent={modalContainer()}
        disableBackdropClick
        handleSubmitButton={onClickNextButton}
        isVisibleCloseButton={false}
        okBtnSty={true}
      />

      <CustomModal
        open={isPreviewModalOpen}
        modalDesign={{}} // Add styles if needed
        modalComponent={previewModalContent()}
        disableBackdropClick={false}
        isVisibleCloseButton={false}
      // No submit button for preview modal
      />
      {/* {console.log("isLoading",isLoading)} */}
      {uploadOcrNricLoading && <LoadingOverlay loading={true} />}
    </>
  );
};

export default IdentityVerification;